(function () {
    function w() {
        var r = document.documentElement;
        var a = r.getBoundingClientRect().width; //获取当前设备的宽度
        if (a > 750) {
            //720不固定，根据设计稿的宽度定
            a = 750;
        }
        rem = a / 7.5;
        r.style.fontSize = rem + "px";
    }
    w();
    window.addEventListener("resize",function () {
            /**小于200是防止虚拟键盘弹出影响 */
            if(document.documentElement.clientHeight<200){
                //监听横竖屏切换
                w();
            };
        },false
    );
})();


// WEBPACK FOOTER //
// ./src/common/js/rem.js